import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSwitch } from "@redotech/redo-web/switch";
import { Text } from "@redotech/redo-web/text";
import { InputProvider, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const wmsEnabledForm = groupInput({
  enabled: input<boolean>(),
  packingParcelsEnabled: input<boolean>(),
  binCoordinateMonitoringEnabled: input<boolean>(),
  binCoordinateMonitoringAlertThresholdPercent: input<number>(),
});

export type WmsEnabledForm = InputProvider.Form<typeof wmsEnabledForm>;

export type WmsEnabledValue = InputProvider.Value<typeof wmsEnabledForm>;

export const wmsEnabledDefault: WmsEnabledValue = {
  enabled: false,
  packingParcelsEnabled: false,
  binCoordinateMonitoringEnabled: false,
  binCoordinateMonitoringAlertThresholdPercent: 80,
};

export const WmsEnabledCard = memo(function WmsEnabledCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  const { wmsEnabled } = input.inputs;

  return (
    <Card title="WMS Settings" w="full">
      <Flex dir="column" gap="md">
        <Text fontSize="sm">
          Enable WMS (Warehouse Management System) functionality for pick
          sessions and warehouse operations.
        </Text>
        <FormSwitch input={wmsEnabled.inputs.enabled} label="Enable WMS" />
        <FormSwitch
          input={wmsEnabled.inputs.packingParcelsEnabled}
          label="Enable packing parcels"
        />
        <FormSwitch
          input={wmsEnabled.inputs.binCoordinateMonitoringEnabled}
          label="Enable bin coordinate monitoring"
        />
        {wmsEnabled.value.binCoordinateMonitoringEnabled && (
          <RedoTextInput
            description="Alert when the percentage of line items with bin coordinates falls below this threshold"
            inputTypeHint="number"
            label="Alert threshold (%)"
            max={100}
            min={0}
            setValue={(value) =>
              wmsEnabled.inputs.binCoordinateMonitoringAlertThresholdPercent.setValue(
                Number(value) || 0,
              )
            }
            value={String(
              wmsEnabled.value.binCoordinateMonitoringAlertThresholdPercent,
            )}
          />
        )}
      </Flex>
    </Card>
  );
});
